/**
 * The standing legal statements the whole site leans on, in one place so they never drift.
 * None of them is a substitute for the workflow: the tools do not perform regulated work in the first place.
 */
export const NOT_A_VALUATION =
  "Research estimate, not a valuation. Any real decision needs a surveyor and a registered valuer.";

export const NOT_AN_OFFER =
  "Research estimates for study and discussion. Not an offer and not professional advice.";

export const NO_ENDORSEMENT =
  "Listed for public-information and research purposes only. No affiliation, sponsorship, approval, appointment or endorsement is stated or implied unless expressly confirmed in writing and identified on this page.";

export const PUBLIC_LEGAL_STATEMENT = [
  "KickStartKenyaFootball is an independent football research and development platform, run from Nairobi and governed by Kenyan law.",
  "The platform provides football research, heritage information, general development scenarios and preliminary opportunity-submission facilities.",
  "KickStartKenyaFootball does not provide estate-agency, valuation, legal, investment-advisory, investment-arranging, financial, architectural, engineering, surveying or other regulated professional services.",
  "It does not accept instructions to buy, sell or let land, introduce a specific property or party to anyone, negotiate property transactions, offer investments or handle transaction funds.",
  "Regulated matters must be handled independently by professionals authorised in the relevant jurisdiction.",
  "Submission of information does not create an agency relationship, promise of funding or entitlement to compensation.",
];

export const PASSIVE_PUBLICATION =
  "Publication of preliminary site information does not mean that KickStartKenyaFootball is instructed to market, sell, acquire or let the site. Interested parties must engage independently through appropriately licensed Kenyan professionals.";

export const SPONSORSHIP_NOT_INVESTMENT =
  "Commercial sponsorship opportunities provide agreed marketing and promotional rights. They are not investments and do not provide equity, repayment, interest or participation in project profits.";

/** The standing legal position, in full. Rendered in the footer of every page. */
export const PublicLegalStatement = ({ className = "" }) => (
  <div data-testid="public-legal-statement" className={`space-y-3 ${className}`}>
    <p className="mono text-[0.55rem] uppercase tracking-[0.18em] text-ochre">The legal position, in full</p>
    {PUBLIC_LEGAL_STATEMENT.map((line, i) => (
      <p key={line} data-testid={`public-legal-line-${i}`} className="max-w-4xl text-xs leading-relaxed text-zinc-400">
        {line}
      </p>
    ))}
  </div>
);

/** Put this wherever a specific site or parcel of land is described. */
export const PassivePublication = ({ className = "" }) => (
  <p data-testid="passive-publication" className={`mono border-l-2 border-zinc-700 bg-[#0b0b0b] px-5 py-4 text-[0.55rem] uppercase leading-relaxed tracking-[0.14em] text-zinc-400 ${className}`}>
    {PASSIVE_PUBLICATION}
  </p>
);

/** Put this wherever sponsorship, naming rights or commercial partnership is offered. */
export const SponsorshipNotInvestment = ({ className = "" }) => (
  <p data-testid="sponsorship-not-investment" className={`mono border-l-2 border-ochre bg-[#0b0b0b] px-5 py-4 text-[0.58rem] uppercase leading-relaxed tracking-[0.14em] text-zinc-300 ${className}`}>
    {SPONSORSHIP_NOT_INVESTMENT}
  </p>
);
const box =
  "mono border-l-2 border-maasai bg-[#0b0b0b] px-5 py-4 text-[0.58rem] uppercase leading-relaxed tracking-[0.14em] text-zinc-300";

/** Put this on any page that prices, plans or draws a specific plot of land. */
export const NotAValuation = ({ className = "" }) => (
  <p data-testid="not-a-valuation" className={`${box} ${className}`}>{NOT_A_VALUATION}</p>
);

/** Put this on any page that publishes a modelled surplus, a value ratio or a funding scenario. */
export const NotAnOffer = ({ className = "" }) => (
  <p data-testid="not-an-offer" className={`${box} ${className}`}>{NOT_AN_OFFER}</p>
);

/** Put this wherever a government body, regulator, federation or county is named. */
export const NoEndorsement = ({ className = "" }) => (
  <p data-testid="no-endorsement" className={`mono border-l-2 border-zinc-700 bg-[#0b0b0b] px-5 py-4 text-[0.55rem] uppercase leading-relaxed tracking-[0.14em] text-zinc-400 ${className}`}>
    {NO_ENDORSEMENT}
  </p>
);
